/** @jsx jsx */
import { jsx } from "theme-ui"
import PropTypes from "prop-types"

import { ab } from "../../theme"

const Captcha = ({
  label,
  name,
  type,
  value,
  placeholder,
  required,
  captcha,
  children,
}) => (
  <div
    sx={{
      py: 3,
    }}
  >
    <label htmlFor={name}>
      {children}
      {required ? " * " : ""}
    </label>

    <div
      sx={{
        display: ab({ _: "block", md: "flex" }),
      }}
    >
      <input
        sx={{
          variant: "form.formField",
          border: 0,
          px: 2,
          my: 2,
          color: "text",
          flex: 4,
          width: "100%",
        }}
        id={name}
        name={name}
        type={type}
        value={value}
        placeholder={placeholder}
        required={required}
      />
      <div
        sx={{
          px: 4,
          my: ab({ _: 3, md: 2 }),
          fontSize: 24,
          flex: 6,
          textAlign: "center",
        }}
      >
        {captcha}
      </div>
    </div>
  </div>
)

Captcha.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  required: PropTypes.bool,
  captcha: PropTypes.node.isRequired,
  children: PropTypes.node,
}

export default Captcha
